import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { AppointmentManualEditor } from "../AppointmentManual/AppointmentManual.editor";
import { AppointmentGroupManualEditor } from "../AppointmentGroupManual/AppointmentGroupManual.editor";


export const Entailment = () => {

    const entailment = useDataBean(_Entailment);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        entailment.instance.getEntailmentCatalog().then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        entailment.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        entailment.deleteItemVoid(entailment.bean.IDEntailment).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Agregar Nivel Jerárquico de Empleo`, "view": false });
            }
        )

    }
    const editaItem = () => {
       //console.log(entailment.bean);
        entailment.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDEntailment', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Código del Manual de funciones', property: 'AppointmentManualCode', visible: true },
        { title: 'Manual de Funciones', property: 'AppointmentManualName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${entailment.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Niveles Jerárquicos del Empleo">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={entailment.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-6">
                                <AppointmentGroupManualEditor idSelector={appoGroup} onChange={(e) => { setAppoGroup(e) }} />
                            </div>
                            <div className="col-6">
                                <AppointmentManualEditor appoGroup={appoGroup} idSelector={entailment.bean.IDAppointmentManual} onChange={(e) => entailment.setBean({ ...entailment.bean, "IDAppointmentManual": e })} />
                            </div>
                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={entailment.bean.Code} onChange={entailment.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={entailment.bean.Name} onChange={entailment.handleChange} />
                                {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {entailment.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}